@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.tree-nav-container {
  height: 100%;
}

.tree-and-batches {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > * {
    position: relative;
  }
}
